import CodeMirror from 'codemirror';
import 'codemirror/mode/jsx/jsx';
import 'codemirror/mode/shell/shell';
import '../styles/codemirror.scss';

import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import pick from 'lodash.pick';

const CodeMirrorEditor = createReactClass({
	displayName: 'CodeMirrorEditor',

	propTypes: {
		className: PropTypes.string,
		defaultValue: PropTypes.string,
		lineNumbers: PropTypes.bool,
		lineWrapping: PropTypes.bool,
		matchBrackets: PropTypes.bool,
		mode: PropTypes.oneOf(['jsx', 'shell']),
		onChange: PropTypes.func,
		readOnly: PropTypes.bool,
		style: PropTypes.object,
		tabSize: PropTypes.number,
		theme: PropTypes.string
	},

	getDefaultProps () {
		return {
			lineNumbers: true,
			lineWrapping: false,
			matchBrackets: true,
			mode: 'jsx',
			readOnly: false,
			tabSize: 2,
			theme: 'default'
		};
	},

	render () {
		return (
			<div style={this.props.style} className={this.props.className}>
				<textarea ref={this.enableCodeMirror} defaultValue={this.props.defaultValue} />
			</div>
		);
	},

	enableCodeMirror (node) {
		if (node) {
			this.codeMirror = CodeMirror.fromTextArea(node, pick(this.props, [
				'lineNumbers',
				'lineWrapping',
				'matchBrackets',
				'mode',
				'readOnly',
				'tabSize',
				'theme'
			]));

			this.codeMirror.on('change', this.handleChange);
		} else {
			this.codeMirror = null;
		}
	},

	handleChange (codeMirror) {
		if (!this.props.readOnly && this.props.onChange) {
			this.props.onChange(codeMirror.getValue());
		}
	}
});

module.exports = CodeMirrorEditor;



// WEBPACK FOOTER //
// ./public/src/components/code-mirror-editor.jsx